import { render, staticRenderFns } from "./OrganizationMdtListDisease.vue?vue&type=template&id=792cdf7c&scoped=true"
import script from "./OrganizationMdtListDisease.vue?vue&type=script&lang=js"
export * from "./OrganizationMdtListDisease.vue?vue&type=script&lang=js"
import style0 from "./OrganizationMdtListDisease.vue?vue&type=style&index=0&id=792cdf7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792cdf7c",
  null
  
)

export default component.exports